import React from "react";
import IPage from "../../interfaces/page"
import ClientRegistrationComponent from "../../components/ClientRegistration/ClientRegistration.component";

const ClientRegistrationPage: React.FunctionComponent<IPage> = (props: IPage) => {
    return <ClientRegistrationComponent></ClientRegistrationComponent>;
};

export default ClientRegistrationPage;
